import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import compose from 'lodash/fp/compose'

import { SubHeaderNav } from 'client/bookmate/blocks/sub-header/sub-header-nav'
import { show } from 'client/shared/reducers/popup-reducer'
import { NavItem } from '../helpers/nav-helper'
import { Dispatch, State } from 'shared/types/redux'

type Props = {
  nav: NavItem[]
  includeSubpaths?: boolean
  isLoggedIn: boolean
  dispatch: Dispatch
}

class SubHeaderNavBox extends Component<Props> {
  render(): JSX.Element {
    const { isLoggedIn, dispatch, nav, includeSubpaths } = this.props

    return (
      <SubHeaderNav
        includeSubpaths={includeSubpaths}
        nav={nav}
        isLoggedIn={isLoggedIn}
        onLinkClick={(url: string): void => {
          if (isLoggedIn) {
            return dispatch(push(url))
          }

          return dispatch(show({ callback: () => dispatch(push(url)) }))
        }}
      />
    )
  }
}

const wrappers = compose(
  connect((state: State) => ({
    isLoggedIn: state.currentUser.auth,
  })),
)

export default wrappers(SubHeaderNavBox)
